import * as types from "../types/failedPrints"

export const addFailedPrint = failedPrint => ({
  type: types.ADD_FAILED_PRINT,
  failedPrint
})

export const removeFailedPrints = printRequestIds => ({
  type: types.REMOVE_FAILED_PRINTS,
  printRequestIds
})

export const removeAllFailedPrints = () => ({
  type: types.REMOVE_ALL_FAILED_PRINTS
})